export default __webpack_public_path__ + "static/media/toxic.afe07a0d.svg";